const discountedEntryIds = new Set<string>();

export function recordDiscount(entryId: string): void {
  discountedEntryIds.add(entryId);
}

export function consumeDiscount(entryId: string): boolean {
  return discountedEntryIds.delete(entryId);
}

export function clearDiscounts(): void {
  discountedEntryIds.clear();
}
